// src/components/NoteDeFrais.js - ROUTING NOTES DE FRAIS
import React, { useState } from 'react';
import NoteDeFraisHubMobile from './notesdefrais/NoteDeFraisHubMobile';
import AjouterNoteDeFraisMobile from './notesdefrais/AjouterNoteDeFraisMobile';
import DetailNoteDeFraisMobile from './notesdefrais/DetailNoteDeFraisMobile';
import CalculateurKilometrique from './CalculateurKilometrique';

function NoteDeFrais({ inspecteurId, onBack }) {
  const [currentView, setCurrentView] = useState('hub');
  const [selectedNoteId, setSelectedNoteId] = useState(null);

  const handleNavigate = (view, noteId = null) => {
    console.log('🚗 ========================================');
    console.log('🚗 NAVIGATION DEMANDÉE');
    console.log('🚗 Vue:', view);
    console.log('🚗 Note ID:', noteId);
    console.log('🚗 Vue actuelle:', currentView);
    console.log('🚗 ========================================');
    
    setCurrentView(view);
    setSelectedNoteId(noteId);
    
    console.log('✅ Vue changée en:', view);
  };

  const handleBackToHub = () => {
    console.log('🔙 Retour au hub');
    setCurrentView('hub');
    setSelectedNoteId(null);
  };

  console.log('🔍 NoteDeFrais Render - currentView:', currentView);

  // Vue hub (liste)
  if (currentView === 'hub') {
    return (
      <NoteDeFraisHubMobile
        onNavigate={handleNavigate}
        onBack={onBack}
      />
    );
  }

  // Vue ajouter
  if (currentView === 'ajouter') {
    return (
      <AjouterNoteDeFraisMobile
        onBack={handleBackToHub}
        onSave={handleBackToHub}
        onNavigate={handleNavigate}
      />
    );
  }

  // Vue detail
  if (currentView === 'detail' && selectedNoteId) {
    return (
      <DetailNoteDeFraisMobile
        noteId={selectedNoteId}
        onBack={handleBackToHub}
        onDelete={handleBackToHub}
      />
    );
  }

  // Vue calculateur
  if (currentView === 'calculateur') {
    console.log('🚗 AFFICHAGE CALCULATEUR KILOMÉTRIQUE');
    return (
      <CalculateurKilometrique
        onBack={handleBackToHub}
        onSave={handleBackToHub}
      />
    );
  }

  // Fallback
  return (
    <NoteDeFraisHubMobile
      onNavigate={handleNavigate}
      onBack={onBack}
    />
  );
}

export default NoteDeFrais;